import mapbox from 'mapbox-gl'

mapbox.accessToken = 'pk.eyJ1IjoiYW5pcnVkaGciLCJhIjoiY2s5aDByM2lpMHE1djNsand0NjBjOXUxbyJ9.YuNopw4wML-ctHaZGydmAA'

const key = {}

export { mapbox, key }